/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Email direction when user is associated with an email detection
 * @export
 */
export const ControlEmailDirection = {
    Sender: 'sender',
    Receiver: 'receiver'
} as const;
export type ControlEmailDirection = typeof ControlEmailDirection[keyof typeof ControlEmailDirection];


export function ControlEmailDirectionFromJSON(json: any): ControlEmailDirection {
    return ControlEmailDirectionFromJSONTyped(json, false);
}

export function ControlEmailDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEmailDirection {
    return json as ControlEmailDirection;
}

export function ControlEmailDirectionToJSON(value?: ControlEmailDirection | null): any {
    return value as any;
}

